// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"ea1f80ca5173489e4772","873":"382d08bf1857a7e01ea7"}[chunkId] + ".js";
};